import {OBJECT, INTEGER, STRING} from '@acng/frontend-rubicon';

export const UHURA_USER_ID = /* @__PURE__ */ OBJECT({
  product_id: INTEGER,
  id: STRING,
});
